'use strict';

namespace Core.Customer {
    class ReviewHotelCard {
        // Attr
        trip: ManageBooking.BookedTrip;
    }
    angular
        .module('core')
        .directive('reviewHotelCard', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: ReviewHotelCard,
                controllerAs: 'rh',
                bindToController: {
                    trip: '='
                },
                templateUrl: 'partials/customer/reviewhotelcard'
            };
        });
}
